import { ComponentChildren } from 'preact'
import classNames from 'classnames'

interface PagerProps {
  isDisabled: boolean
  isChevron?: boolean
  customClass?: string
  children?: ComponentChildren
  onClick?: (e: Event) => void
  'data-qa'?: string
}

const Pager = ({ isDisabled, isChevron = false, onClick, children, customClass = '', ...restProps }: PagerProps) => {
  const options = {
    class: classNames(
      'control-pagination--pager-item',
      isDisabled ? 'disabled' : null,
      isChevron ? 'chevron' : null,
      customClass
    ),
    onClick: !isDisabled ? onClick : undefined
  }
  return <div {...restProps} {...options}>{children}</div>
}

export default Pager
